let search = {
  load() {
    // Assurer que le DOM est bien chargé
    document.addEventListener("DOMContentLoaded", function () {
      const searchForm = document.getElementById("search-formations");

      // Vérifie si l'élément existe avant d'ajouter l'événement
      if (searchForm) {
        searchForm.addEventListener("submit", function (e) {
          e.preventDefault(); // Empêche le rechargement de la page
          const form = e.target;
          const formData = new FormData(form);

          // Construction de l'URL avec les paramètres
          const queryParams = new URLSearchParams(formData).toString();

          fetch(form.action + "?" + queryParams, {
            method: "GET",
            headers: {
              "X-Requested-With": "XMLHttpRequest", // Indique que c'est une requête AJAX
            },
          })
            .then((response) => response.text())
            .then((data) => {
              // Mettre à jour la liste des formations avec les résultats
              document.getElementById("formation-list").innerHTML = data;
            })
            .catch((error) =>
              console.error("Erreur lors de la requête AJAX :", error),
            );
        });
      } else {
        console.warn("Le formulaire de recherche n'a pas été trouvé!");
      }
    });
  },
};

export default search;
